import React from 'react';

import { useTranslation } from 'react-i18next';

import { Stack, Divider, Typography } from '@packages/fenrir/components';

import { AssetInformation } from '../asset-information/asset-information';
import { AssetIpTable } from '../asset-ip-table/asset-ip-table';

export interface AssetNetworkContentProps
  extends React.ComponentProps<typeof Stack> {
  assetId: string;
}

export const AssetNetworkContent: React.FC<AssetNetworkContentProps> = ({
  assetId,
  ...rest
}) => {
  const { t } = useTranslation('ads');

  return (
    <Stack sx={{ gap: 3 }} {...rest} direction="row">
      <Stack sx={{ gap: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 'fontWeightBold' }}>
          {t('assetDetails.networkInterfaceDetails')}
        </Typography>
        <AssetIpTable assetId={assetId} />
      </Stack>
      <Divider orientation="vertical" flexItem />
      <Stack sx={{ gap: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 'fontWeightBold' }}>
          {t('assetDetails.deviceDetails')}
        </Typography>
        <AssetInformation.Root>
          <AssetInformation.Field
            assetId={assetId}
            property="hostname"
            skeletonProps={{ width: '6rem' }}
          />
          <AssetInformation.Os assetId={assetId} />
          <AssetInformation.Field
            assetId={assetId}
            property="netbios"
            skeletonProps={{ width: '6rem' }}
          />
        </AssetInformation.Root>
      </Stack>
    </Stack>
  );
};
